// Get DOM elements
const sendAsGiftCheckbox = document.getElementById('sendAsGift');
const giftDetails = document.querySelector('.gf-gift-details');
const recipientEmailInput = document.getElementById('recipientEmail');
const recipientNameInput = document.getElementById('recipientName');
const messageInput = document.getElementById('message');
const sendDateInput = document.getElementById('sendDate');
const addToCartButton = document.getElementById('product-add-to-cart');
const emailError = document.getElementById('emailError');
const nameError = document.getElementById('nameError');
const messageError = document.getElementById('messageError');
const dateError = document.getElementById('dateError');
// Listen for change event on the checkbox
sendAsGiftCheckbox.addEventListener('change', function () {
    if (sendAsGiftCheckbox.checked) {
        giftDetails.classList.add('visible');
        validateDate();
        validateEmailAndUpdateUI();
    } else {
        giftDetails.classList.remove('visible');
        addToCartButton.disabled = false;
    }
});

function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
}

// validate the email and update UI 
function validateEmailAndUpdateUI() {
    const email = recipientEmailInput.value;
    if (!isValidEmail(email)) {
        emailError.textContent = 'Please enter a valid email address.';
        addToCartButton.disabled = true;
    } else {
        emailError.textContent = '';
    }
}

recipientEmailInput.addEventListener('change', validateEmailAndUpdateUI);
recipientEmailInput.addEventListener('focus', validateEmailAndUpdateUI);
recipientEmailInput.addEventListener('focusout', validateEmailAndUpdateUI);


// Name validation
recipientNameInput.addEventListener('blur', function () {
    const name = recipientNameInput.value;
    if (name.trim() === '') {
        nameError.textContent = 'Please enter a valid name.';
    } else {
        nameError.textContent = '';
    }
});

// Message validation
messageInput.addEventListener('blur', function () {
    const message = messageInput.value;
    if (message.length > 200) {
        messageError.textContent = 'The message should not exceed 200 characters.';
    } else {
        messageError.textContent = '';
    }
});


// Function to validate the date and enable/disable the button
function validateDate() {
    const currentDate = Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate());
    const inputDateValue = sendDateInput.value;
    const selectedDate = inputDateValue ? Date.UTC(new Date(inputDateValue).getUTCFullYear(), new Date(inputDateValue).getUTCMonth(), new Date(inputDateValue).getUTCDate()) : NaN;
    const errorMessage = document.getElementById('dateError');

    let message = '';
    let isButtonDisabled = true;

    if (inputDateValue && !isNaN(selectedDate)) {
        if (selectedDate < currentDate) {
            message = 'Please choose today or a date after.';
        } else {
            message = '';
            isButtonDisabled = false;
        }
    } else {
        message = 'Invalid date. Please enter a valid date.';
    }

    addToCartButton.disabled = isButtonDisabled;
    errorMessage.textContent = message;
    errorMessage.style.display = message ? 'block' : 'none';
}

sendDateInput.addEventListener('change', validateDate);
sendDateInput.addEventListener('focus', validateDate);
sendDateInput.addEventListener('blur', validateDate);
